<template>
  <div class="loc-product-aromas">
    <p class="is-size-16px has-text-weight-semibold mb10">Aromas</p>
    <div class="terpene-tag bg-secondary-light" v-bind:key="'aroma_' + aroma.id" v-for="aroma in aromas">
      <div class="aroma-tag">
        <span v-html="aromasIcon[aroma.name] ? aromasIcon[aroma.name] : aromasIcon['Skunky']"></span> <span class="text-dark">{{ aroma.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';
import Env from '@/env';

export default {
  name: 'LocationProductAromas',
  data() {
    return {

    };
  },
  
  props:{
    aromas: {
      required: true,
      type: Array,
    },
  },

  computed: {
    aromasIcon() {
      return Env.aromasIcon;
    },
  },

  mounted() {

  },
  
  methods: {

  

  },
};
</script>
